export const messagesIntegration = {
  pt: {
    message: {
      allowSaveClientData:
        "Permitir salvar dados dos clientes na plataforma Wifeed",
      accessData: "Dados do acesso",
      accessDate: "Data de acesso",
      accessId: "ID de acesso",
      content: "Conteúdo",
      createIntegration: "Criar integração",
      discardRecords: "Descartar registros",
      editIntegration: "Editar Integração",
      error: "Erro",
      errorMessage: "Mensagem de Erro",
      establishmentDetails: "Dados do estabelecimento",
      integrationRecord: "Registro de integração",
      integrationTest: "Teste integração",
      location: "Local",
      newIntegration: "Nova Integração",
      recordsNotSent: "Registros não enviados",
      registrationDate: "Data de registro",
      removeIntegration: "Remover Integração",
      removeIntegrationConfirmation:
        "Você tem certeza que deseja remover essa integração?",
      resendRecords: "Reenviar registros",
      send: "Enviar",
      testExternalBaseAccess: "Testar acesso à base externa",
      userData: "Dados do usuário",
      userFound: "Usuário encontrado.",
      userFoundButNoData:
        "O usuário foi encontrado, porém a integração não foi configurada para trazer suas informações.",
      userNotFound: "Usuário não encontrado.",
      viewContent: "Visualizar conteúdo",
      viewError: "Visualizar erro",
      warningEmail: "E-mail de aviso",
    },
  },
  es: {
    message: {
      allowSaveClientData:
        "Permitir guardar datos de clientes en la plataforma Wifeed",
      accessData: "Datos de acceso",
      accessDate: "Fecha de acceso",
      accessId: "ID de acceso",
      content: "Contenido",
      createIntegration: "Crear integración",
      discardRecords: "Descartar registros",
      editIntegration: "Editar integración",
      error: "Error",
      errorMessage: "Mensaje de error",
      establishmentDetails: "Detalles del establecimiento",
      integrationRecord: "Registro de integración",
      integrationTest: "Teste integración",
      newIntegration: "Nueva integración",
      recordsNotSent: "Registros no enviados",
      registrationDate: "Fecha de registro",
      removeIntegration: "Eliminar la integración",
      removeIntegrationConfirmation:
        "¿Estás seguro de que quieres eliminar esta integración?",
      resendRecords: "Reenviar registros",
      send: "Enviar",
      testExternalBaseAccess: "Probar el acceso a la base de datos externa",
      userData: "Datos do usuario",
      userFound: "Usuario encontrado.",
      userFoundButNoData:
        "Se encontró al usuario, pero no se configuró la integración para recuperar su información.",
      userNotFound: "Usuario no encontrado.",
      viewContent: "Ver contenido",
      viewError: "Ver error",
      warningEmail: "Correo electrónico de advertencia",
    },
  },
  en: {
    message: {
      allowSaveClientData: "Allow saving customer data on the Wifeed platform",
      accessData: "Access data",
      accessDate: "Access date",
      accessId: "Access ID",
      content: "Content",
      createIntegration: "Create integration",
      discardRecords: "Discard records",
      editIntegration: "Edit integration",
      error: "Error",
      errorMessage: "Error Message",
      establishmentDetails: "Establishment details",
      integrationRecord: "Integration record",
      integrationTest: "Integration test",
      newIntegration: "New integration",
      recordsNotSent: "Records not sent",
      registrationDate: "Registration date",
      removeIntegration: "Remove Integration",
      removeIntegrationConfirmation:
        "Are you sure you want to remove this integration?",
      resendRecords: "Resend records",
      send: "Send",
      testExternalBaseAccess: "Test external database access",
      userData: "User data",
      userFound: "User found.",
      userFoundButNoData:
        "The user was found, but the integration was not configured to retrieve their information.",
      userNotFound: "User not found.",
      viewContent: "View content",
      viewError: "View error",
      warningEmail: "Warning email",
    },
  },
};
